import type {SketchLineObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {SketchLineMultiRelationConstraint} from './SketchLineMultiRelationConstraint';

let count = 0;

/**
 * 判断对象是否为线角度关系。
 * @param value 待判断对象。
 * @returns 是否为角度关系。
 */
export function isLineAngleConstraint(value: object): value is LineAngleConstraint {
    return Reflect.get(value, 'isLineAngleConstraint') === true;
}

/**
 * 两直线有符号角度关系定义。
 *
 * 角度分支由锁定值符号表达，几何计算由统一参数公式完成。
 */
export class LineAngleConstraint extends SketchLineMultiRelationConstraint<SketchLineObject> {
    /** 运行时类型标记。 */
    public readonly isLineAngleConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Angle;
    /** 锁定有符号角度。 */
    private lockedSignedAngleRad: number | null = null;

    /**
     * @param signedAngleRad 锁定有符号角度；未提供时保持未锁定。
     */
    public constructor(signedAngleRad?: number) {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
        if (typeof signedAngleRad === 'number') {
            this.setLockedSignedAngle(signedAngleRad);
        }
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '角度';
    }

    /** @returns 锁定有符号角度；未锁定返回 null。 */
    public getLockedSignedAngle(): number | null {
        return this.lockedSignedAngleRad;
    }

    /**
     * 设置锁定有符号角度。
     * @param signedAngleRad 新角度。
     */
    public setLockedSignedAngle(signedAngleRad: number): void {
        if (!Number.isFinite(signedAngleRad)) {
            return;
        }
        this.lockedSignedAngleRad = signedAngleRad;
    }
}
